import "./App.css";
import { BrowserRouter } from "react-router-dom";

import Routes from "./routes/routes";
import { AuthProvider } from "./Context/AuthContext";
function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
